import { render, staticRenderFns } from "./glbUpload.vue?vue&type=template&id=2994259f&scoped=true"
import script from "./glbUpload.vue?vue&type=script&lang=js"
export * from "./glbUpload.vue?vue&type=script&lang=js"
import style0 from "./glbUpload.vue?vue&type=style&index=0&id=2994259f&prod&scoped=true&lang=css"
import style1 from "./glbUpload.vue?vue&type=style&index=1&id=2994259f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2994259f",
  null
  
)

export default component.exports